export default "__VITE_ASSET__CCDYXTAK__"